import { FC } from "react";
import { useField } from "formik";
import classNames from "classnames";

import styles from "./FormikSelectField.module.css";

type SelectOption = string | { value: string; label: string };

interface FormikSelectFieldProps {
  name: string;
  label?: string;
  options: readonly SelectOption[];
  placeholder?: string;
  disabled?: boolean;
}

const FormikSelectField: FC<FormikSelectFieldProps> = ({
  name,
  label,
  options,
  placeholder,
  disabled,
}) => {
  const [field, meta] = useField(name);
  const hasError = meta.touched && meta.error;

  return (
    <label className={styles.field}>
      {label && <p className={styles.field__label}>{label}</p>}
      <select
        {...field}
        disabled={disabled}
        className={classNames(styles.field__select, hasError && styles.field__error)}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => {
          const value = typeof option === "string" ? option : option.value;
          const label = typeof option === "string" ? option : option.label;
          return (
            <option key={value} value={value}>
              {label}
            </option>
          );
        })}
      </select>
      {hasError && <p className={styles.field__errorText}>{meta.error}</p>}
    </label>
  );
};

export default FormikSelectField;
